import API from 'shared/constants/api';

export const sandEmail = async (data, fetch) => {
  const { service, slug, phone, name, advertId } = data;

  const formData = JSON.stringify({
    service,
    slug,
    phone: phone.replace(/\s/g, ''),
    name,
    advertId,
  });

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: formData,
  };

  try {
    const result = await fetch(API.DEALERS.REQUEST_SERVICE, options).then(r => r.json());
    if (!result || result.err) {
      console.log(result || result.err);
      return false;
    }
  } catch (err) {
    console.log(err);
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/shared/components/DealerServiceExchangeForm/service.js